enum SecondaryDocumentTypeEnum {
    PASSPORT = 'PASSPORT',
    DRIVING_LICENSE = 'DRIVING_LICENSE',
    GUN_LICENSE = 'GUN_LICENSE',
    BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
    INSURANCE_CARD = 'INSURANCE_CARD',
    ACADEMIC_CARD = 'ACADEMIC_CARD',
}

export default SecondaryDocumentTypeEnum;
